import React, { useEffect, useState } from "react";
import ChatPage from "./ChatPage";
import { Product } from "../constants";
import HomeDashboard from "./Home/HomePage";
import api from "../api";

export default function HomePage({
    GAEvent,
    botName,
    sendMessage,
    sendEvent,
    messages,
    userId,
    agentName,
    uploadFile,
    welcomeMsg,
    roomClosed,
    csatDone,
    setCsatDone,
    roomId,
    roomToken,
    isOffline,
    restartChat,
    closeChat,
    messageCounter,
    offlineMsg,
    displayAllOptions,
    clearRoomData,
    showPlansComparison,
    closeComparision,
    planComparison,
    productId,
    regenDoc,
    customerFeedback,
    customerQueryResolutionFeedback,
    planFeatures,
    closePlanFeaturePopup,
    ShowPlanFeatures,
    setRoomview,
    chatView,
    isService,
    getHistoryMessages,
    oldMessages,
    serviceAgentFeedback,
    lastHistoryMsg,
    empId,
    showHistory,
    haveExistingChat,
    setHaveExistingChat,
    source,
    isOfflineWorkingHour,
    offWorkingHourMsg,
    askForRating,
    setTabHasFocus,
    loader,
    chatDivRef,
    newTermUi,
    onCallInitialized,
    onCallDisconnect,
    onCallProcessing,
    webCallIdRef,
    webCallingEnable,
    askForRatingTicket,
    ticketRatingDone,
    ticketInactivityClosed,
    showVideoCallButton,
    agentMsgReplied,
    setAgentMsgReplied,
    customerName,
    totalMsgs
}) {
    const [startChat, setStartChat] = useState(chatView || false)
    const [faqs, setFQAs] = useState([])
    useEffect(async () => {
        if(productId === Product.Home ){
        let resp = await api.getFAQ(roomToken)
        if (resp && resp.code === 200) {
            setFQAs(resp.result)
        }
    }
    }, [])
    useEffect(() => {
        setStartChat(chatView)
    }, [chatView])
    //console.log(startChat)
    const miniMize = (e) => {
        // e.preventDefault();
        console.log("minimizing ini");
        if (window && window.parent) {
            console.log("minimizing start");
            window.parent.postMessage({ message: 'Box minimize.', minimize: true }, '*');
        } else {
            console.log("minimizing not  start");
        }
        GAEvent({ eventAction: "Chat-Minimizes", eventLabel: "Click-Chat-Minimizes" })
    }

    return (
        <>
            {startChat ?
                <ChatPage
                    GAEvent={GAEvent}
                    botName={botName}
                    sendMessage={sendMessage}
                    sendEvent={sendEvent}
                    messages={messages}
                    userId={userId}
                    agentName={agentName}
                    uploadFile={uploadFile}
                    welcomeMsg={welcomeMsg}
                    roomClosed={roomClosed}
                    csatDone={csatDone}
                    setCsatDone={setCsatDone}
                    roomId={roomId}
                    roomToken={roomToken}
                    isOffline={isOffline}
                    restartChat={restartChat}
                    closeChat={closeChat}
                    messageCounter={messageCounter}
                    offlineMsg={offlineMsg}
                    displayAllOptions={displayAllOptions}
                    clearRoomData={clearRoomData}
                    showPlansComparison={showPlansComparison}
                    closeComparision={closeComparision}
                    planComparison={planComparison}
                    productId={productId}
                    regenDoc={regenDoc}
                    customerFeedback={customerFeedback}
                    customerQueryResolutionFeedback={customerQueryResolutionFeedback}
                    planFeatures={planFeatures}
                    closePlanFeaturePopup={closePlanFeaturePopup}
                    ShowPlanFeatures={ShowPlanFeatures}
                    isService={isService}
                    getHistoryMessages={getHistoryMessages}
                    oldMessages={oldMessages}
                    serviceAgentFeedback={serviceAgentFeedback}
                    lastHistoryMsg={lastHistoryMsg}
                    empId={empId}
                    showHistory={showHistory}
                    haveExistingChat={haveExistingChat}
                    setHaveExistingChat={setHaveExistingChat}
                    source={source}
                    isOfflineWorkingHour={isOfflineWorkingHour}
                    offWorkingHourMsg={offWorkingHourMsg}
                    askForRating={askForRating}
                    setTabHasFocus={setTabHasFocus}
                    loader={loader}
                    chatDivRef={chatDivRef}
                    newTermUi={newTermUi}
                    onCallInitialized ={onCallInitialized}
                    onCallDisconnect={onCallDisconnect}
                    onCallProcessing={onCallProcessing}
                    webCallIdRef={webCallIdRef}
                    webCallingEnable={webCallingEnable}
                    askForRatingTicket={askForRatingTicket}
                    ticketRatingDone={ticketRatingDone}
                    ticketInactivityClosed={ticketInactivityClosed}
                    showVideoCallButton={showVideoCallButton}
                    agentMsgReplied={agentMsgReplied}
                    setAgentMsgReplied={setAgentMsgReplied}
                    customerName={customerName}
                    totalMsgs={totalMsgs}
                />
                :
                <>
                    {productId === Product.Home ?
                        <HomeDashboard
                            miniMize={miniMize}
                            roomToken={roomToken}
                            setRoomview={setRoomview}
                            setStartChat={setStartChat}
                            faqs={faqs} 
                            sendMessage={sendMessage}
                            />
                        : null}
                </>
            }
        </>
    );
}
